import { render, staticRenderFns } from "./CustomerKnowledgePopup.vue?vue&type=template&id=52b155c6"
import script from "./CustomerKnowledgePopup.vue?vue&type=script&lang=js"
export * from "./CustomerKnowledgePopup.vue?vue&type=script&lang=js"
import style0 from "./CustomerKnowledgePopup.vue?vue&type=style&index=0&id=52b155c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports